import { Capacitor } from "@capacitor/core";
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import type { Auth } from "firebase/auth";
import {
  browserLocalPersistence,
  getAuth,
  indexedDBLocalPersistence,
  initializeAuth,
  setPersistence,
} from "firebase/auth";
import { getStripePayments } from "@stripe/firestore-stripe-payments";
import "firebase/storage";
import { getStorage, type FirebaseStorage } from "firebase/storage";

console.log("[firebaseConfig] Preparing to initialize Firebase");

// Firebase configuration
const firebaseConfig = {
  // IMPORTANT: storageBucket must remain the firebasestorage.app domain –
  // the legacy appspot bucket no longer exists and breaks web CORS.
  apiKey: "AIzaSyCXjLWw7XwOQqeyc7F59MQYHyx9fmoHgxI",
  authDomain: "cabinet-logger.firebaseapp.com",
  projectId: "cabinet-logger",
  storageBucket: "cabinet-logger.firebasestorage.app",
  messagingSenderId: "281767009870",
  appId: "1:281767009870:web:a5cbcc33765dcfbe7f2d1f",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
console.log("[firebaseConfig] Firebase app initialized", {
  projectId: firebaseConfig.projectId,
});

// Initialize Firebase services
const db = getFirestore(app);
console.log("[firebaseConfig] Firestore instance created");
const storage: FirebaseStorage = getStorage(app);
console.log("[firebaseConfig] Storage instance created");

export const ensureStorage = (): Promise<FirebaseStorage> => Promise.resolve(storage);
let auth: Auth;
if (Capacitor.isNativePlatform()) {
  console.log(
    "[firebaseConfig] Initializing auth with indexedDBLocalPersistence for native platform"
  );
  auth = initializeAuth(app, {
    persistence: indexedDBLocalPersistence,
  });
  console.log("[firebaseConfig] initializeAuth completed for native platform");
} else {
  console.log("[firebaseConfig] Using getAuth for web platform");
  auth = getAuth(app);
  setPersistence(auth, browserLocalPersistence)
    .then(() => {
      console.log("[firebaseConfig] Browser persistence set to local");
    })
    .catch((error) => {
      console.error(
        "[firebaseConfig] Failed to set browser persistence",
        error
      );
    });
}

// Initialize Stripe Payments with specific collections
const payments = getStripePayments(app, {
  customersCollection: "users", // Using 'users' as the customer collection
  productsCollection: "products", // Your manually created 'products' collection
});
console.log("[firebaseConfig] Stripe payments initialized");

export { db, auth, payments, app, storage };
